import { Fragment } from 'react';
import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { store } from './redux/store';
import { CharacterCreation } from './views/CharacterCreation';
import { Background } from './components/Background';

const LayoutComponent = () => (
	<Provider store={store}>
		<Fragment>
			<Background />
			<CharacterCreation />
		</Fragment>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.CharacterCreation)
	.build();

export default Layout;
